import { useMediaQuery } from '@uidotdev/usehooks';
import { breakpoints } from '../configs/breakpoints';

export interface Breakpoints {
	mobile: boolean;

	tablet: boolean;

	desktopS: boolean;

	desktopM: boolean;

	desktopXL: boolean;

	desktopXXL: boolean;
}

export const useBreakpoint = (): Breakpoints => ({
	mobile: useMediaQuery(
		`only screen and (max-width : ${breakpoints.tablet - 1}px)`,
	),
	tablet: useMediaQuery(
		`only screen and (min-width : ${breakpoints.tablet}px) and (max-width : ${breakpoints.desktopS - 1}px)`,
	),
	desktopS: useMediaQuery(
		`only screen and (min-width : ${breakpoints.desktopS}px) and (max-width : ${breakpoints.desktopM - 1}px)`,
	),

	desktopM: useMediaQuery(
		`only screen and (min-width : ${breakpoints.desktopM}px) and (max-width : ${breakpoints.desktopXL - 1}px)`,
	),
	desktopXL: useMediaQuery(
		`only screen and (max-width : ${breakpoints.desktopXL}px)`,
	),
	desktopXXL: useMediaQuery(
		`only screen and (min-width : ${breakpoints.desktopXXL}px)`,
	),
});
